@if (noHeaderFooterMode) {
  <div class="layout">
    <app-header [isDefaultHeaderMode]="defaultHeaderMode"></app-header>
    @if (defaultHeaderMode) {
      <app-nav-bar></app-nav-bar>
    }
    <router-outlet></router-outlet>
    @if (defaultHeaderMode && !noFooterMode) {
      <app-footer></app-footer>
    }
  </div>
}
@if (!noHeaderFooterMode) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
<ng-template #timeoutModal>
  <div class="bgCover"></div>
  <div id="sessionPopUp">
    <a href="javascript:void(0);"><span class="sessionButClose" (click)="extendSession()"></span></a>
    <div id="pop_header">
      <h3>{{content.SESSION_TIMEOUT_TITLE}}</h3>
    </div>
    <div class="confPopup">
      <span id="timeDisplay">{{currentIdleTime}}</span><p>{{content.SESSION_TIMEOUT_CONTENT}}</p>
      <p>{{content.SESSION_TIMEOUT_SUB_CONTENT}}</p>
    </div>
    <div class="okBtn">
      <img src="assets/images/BTN_SECONDARY_OK.png" alt="ok" class="button" (click)="extendSession()">
    </div>
  </div>
</ng-template>